<div class="container">
    <img src="https://storage.googleapis.com/rxbc-pyxis-ui/content/img/RelayHealthLogo.gif"
        sizes="(max-width: 800px) 800px, 400px" priority class="center">
    <!-- <mat-label class="custom-label">
       This application is used to maintain the configurations for the Pricing Service.
    </mat-label> -->
</div>